<template>
  <div>
    <v-app-bar id="home-app-bar" app color="white" elevation="1" height="80">
      <base-img
        :src="require('@/assets/logo.png')"
        class="mr-3"
        contain
        max-width="80"
        width="100%"
        style="cursor: pointer"
        v-on:click.stop="navigateHome"
      />

      <h1
        style="white-space: nowrap; cursor: pointer"
        v-on:click.stop="navigateHome"
      >
        Media Hoarder
      </h1>

      <v-spacer />

      <v-btn
        text
        v-on:click.stop="showLanguageSelection = !showLanguageSelection"
        ><v-icon>mdi-comment-outline</v-icon> {{ $t("languageID") }}</v-btn
      >

      <div>
        <v-tabs class="hidden-sm-and-down" optional>
          <v-tab
            v-for="(name, i) in items"
            :key="i"
            :to="{ name }"
            :exact="name === 'Home'"
            :ripple="false"
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            text
            >{{ $t(name) }}</v-tab
          >
        </v-tabs>
      </div>

      <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer" />
    </v-app-bar>

    <home-drawer v-model="drawer" :items="items" />

    <v-dialog
      class="secondary"
      max-width="1000px"
      v-model="showLanguageSelection"
    >
      <v-card>
        <v-card-title>
          <div class="headline" style="width: 100%; font-size: 1.17em">
            {{ $t("Language Selection") }}
          </div>
        </v-card-title>
        <v-card-text>
          <div
            v-for="language in availableLanguages"
            v-bind:key="language.code"
            style="width: 100%; display: flex; justify-content: center"
          >
            <v-btn
              text
              v-bind:color="language.code === $i18n.locale ? 'primary' : ''"
              syle="min-width: 250px!important"
              v-on:click.stop="changeLanguage(language)"
            >
              {{ language.name }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "HomeAppBar",

  components: {
    HomeDrawer: () => import("./Drawer"),
  },

  data: () => ({
    drawer: null,
    items: [
      "Home",
      "Downloads",
      "Features",
      "Getting Started",
      // "Forum",
      "Blog",

      // 'About',
      // 'Marketing',
      // 'Gallery',
      // 'Pricing',
      // 'News',
      // 'Contact',
    ],

    showLanguageSelection: false,
    availableLanguages: [],
  }),

  methods: {
    changeLanguage(language) {
      this.$i18n.locale = language.code;
      this.$root.$i18n.locale = language.code;
      this.showLanguageSelection = false;
    },

    navigateHome() {
      this.$router.push("/");
    },
  },

  created() {
    this.availableLanguages = this.$i18n.availableLocales.map((locale) => {
      return {
        code: locale,
        name: this.$i18n._vm.messages[locale].languageName,
      };
    });
  },
};
</script>

<style lang="sass">
#home-app-bar
  .v-tabs-slider
    max-width: 24px
    margin: 0 auto

    .v-tab
      &::before
        display: none
</style>
